<p-dialog [header]="header" [visible]="true" [modal]="true" [style]="{ width: '760px', maxWidth: '95vw' }"
  [breakpoints]="{ '960px': '85vw', '640px': '95vw' }" [draggable]="false" [resizable]="false"
  [styleClass]="'ef-model-parameters-dialog'" (visibleChange)="onClose()">

  <ng-template #parameterRow let-row>
    <tr>
      <td class="ef-model-parameters__cell ef-model-parameters__cell--name">{{ row.label }}</td>

      <td class="ef-model-parameters__cell">
        <span *ngIf="row.isAutomatic; else initialValueInput"
          class="ef-model-parameters__automatic">{{ texts.AUTOMATIC_LABEL }}</span>
        <ng-template #initialValueInput>
          <p-inputNumber [useGrouping]="false" [minFractionDigits]="0"
            [maxFractionDigits]="texts.MAX_FRACTION_DIGITS" [allowEmpty]="true" [ngModel]="row.initialValue"
            [inputStyleClass]="'ef-model-parameters__input'"
            (ngModelChange)="onInitialValueChange(row, $event)"></p-inputNumber>
        </ng-template>
      </td>

      <td class="ef-model-parameters__cell ef-model-parameters__cell--fixed">
        <p-checkbox [binary]="true" [disabled]="row.isAutomatic" [ngModel]="row.isFixed"
          (ngModelChange)="onFixedChange(row, $event)"></p-checkbox>
      </td>

      <td class="ef-model-parameters__cell">
        <p-inputNumber [useGrouping]="false" [minFractionDigits]="0"
          [maxFractionDigits]="texts.MAX_FRACTION_DIGITS" [allowEmpty]="true" [ngModel]="row.lowerLimit"
          [inputStyleClass]="'ef-model-parameters__input'"
          (ngModelChange)="onLowerLimitChange(row, $event)"></p-inputNumber>
      </td>

      <td class="ef-model-parameters__cell">
        <p-inputNumber [useGrouping]="false" [minFractionDigits]="0"
          [maxFractionDigits]="texts.MAX_FRACTION_DIGITS" [allowEmpty]="true" [ngModel]="row.upperLimit"
          [inputStyleClass]="'ef-model-parameters__input'"
          (ngModelChange)="onUpperLimitChange(row, $event)"></p-inputNumber>
      </td>
    </tr>
  </ng-template>

  <ng-template #tableHeader>
    <thead>
      <tr>
        <th class="ef-model-parameters__cell ef-model-parameters__cell--name">Name</th>
        <th class="ef-model-parameters__cell">Initial Value</th>
        <th class="ef-model-parameters__cell ef-model-parameters__cell--fixed">Fixed</th>
        <th class="ef-model-parameters__cell">Lower Limit</th>
        <th class="ef-model-parameters__cell">Upper Limit</th>
      </tr>
    </thead>
  </ng-template>

  <section class="ef-model-parameters__section">
    <h4 class="ef-model-parameters__title">{{ texts.PARENT_SECTION_TITLE }}</h4>

    <table class="ef-model-parameters__table">
      <ng-container *ngTemplateOutlet="tableHeader"></ng-container>
      <tbody>
        <ng-container *ngFor="let row of parameters.parentRows; trackBy: trackByKey">
          <ng-container *ngTemplateOutlet="parameterRow; context: { $implicit: row }"></ng-container>
        </ng-container>
      </tbody>
    </table>
  </section>

  <section class="ef-model-parameters__section" *ngIf="parameters.metabolites.length > 0">
    <h4 class="ef-model-parameters__title">{{ texts.METABOLITE_SECTION_TITLE }}</h4>

    <div class="ef-model-parameters__models">
      <div class="ef-model-parameters__model" *ngFor="let nodeKey of selectableMetaboliteKeys">
        <div *ngIf="isPrimaryMetabolite(nodeKey)" class="ef-model-parameters__model-inline">
          <span class="ef-model-parameters__model-name">{{ getNodeName(nodeKey) }}</span>
          <div class="ef-model-parameters__model-options">
            <div class="ef-model-parameters__model-option" *ngFor="let option of metaboliteModelOptions; let last = last">
              <p-radioButton [name]="'efMetaboliteModel-' + nodeKey" [inputId]="'efMetaboliteModel-' + nodeKey + '-' + option"
                [value]="option" [ngModel]="getMetaboliteModelType(nodeKey)"
                (ngModelChange)="onMetaboliteModelChange(nodeKey, $event)"></p-radioButton>
              <label class="ef-model-parameters__model-label"
                [for]="'efMetaboliteModel-' + nodeKey + '-' + option">{{ option }}</label>
              <div *ngIf="!last" class="ef-model-parameters__option-separator"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <table class="ef-model-parameters__table">
      <ng-container *ngTemplateOutlet="tableHeader"></ng-container>
      <tbody>
        <ng-container *ngFor="let metabolite of parameters.metabolites; trackBy: trackByNodeKey">
          <ng-container *ngFor="let row of metabolite.rows; trackBy: trackByKey">
            <ng-container *ngTemplateOutlet="parameterRow; context: { $implicit: row }"></ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </section>

  <ng-template pTemplate="footer">
    <div class="ef-model-parameters__footer">
      <app-button class="ef-model-parameters__reset-button" [label]="'Reset'" [icon]="'pi pi-refresh'" [outlined]="true"
        (onClickEvent)="onReset()"></app-button>
    </div>
  </ng-template>
</p-dialog>
